export default {
  scheduler: 'Scheduler',
  'scheduler.info': 'Scheduler Info',
  'scheduler.header.title': '{{entity}} Scheduler ({{count}})',
  'scheduler.result':
    'Occurs <strong>{{occurs}}</strong>, starting {{startAt}}.',
  'scheduler.startedAt': 'Started at',
  'scheduler.duration': 'Repeat Every',
  'scheduler.occurrences': 'Occurrences',
  'scheduler.weekdays.sunday': 'Sunday',
  'scheduler.weekdays.monday': 'Monday',
  'scheduler.weekdays.tuesday': 'Tuesday',
  'scheduler.weekdays.wednesday': 'Wednesday',
  'scheduler.weekdays.thursday': 'Thursday',
  'scheduler.weekdays.friday': 'Friday',
  'scheduler.weekdays.saturday': 'Saturday',
  'scheduler.weekdays.short.sunday': 'Sun',
  'scheduler.weekdays.short.monday': 'Mon',
  'scheduler.weekdays.short.tuesday': 'Tue',
  'scheduler.weekdays.short.wednesday': 'Wed',
  'scheduler.weekdays.short.thursday': 'Thu',
  'scheduler.weekdays.short.friday': 'Fri',
  'scheduler.weekdays.short.saturday': 'Sat',
  'scheduler.duration.end': 'End Reason',
  'scheduler.duration.endDate': 'End Date',
  'scheduler.duration.end.day': 'On this day',
  'scheduler.duration.end.after': 'After',
  'scheduler.duration.end.no': 'No end day',
  'scheduler.separator.and': ' and',
  'scheduler.separator.on': 'on',
  'scheduler.separator.day': 'day',
  'scheduler.separator.every': 'every',
  'scheduler.separator.of': 'of',
  'scheduler.separator.the': 'the',
  'scheduler.day.first': 'First',
  'scheduler.day.second': 'Second',
  'scheduler.day.third': 'Third',
  'scheduler.day.fourth': 'Fourth',
  'scheduler.day.last': 'Last',
  'scheduler.weekday': 'Weekday',
  'scheduler.weekend': 'Weekend Day',
  'scheduler.day': 'Day',
  'scheduler.days': 'Days',
  'scheduler.week': 'Week',
  'scheduler.weeks': 'Weeks',
  'scheduler.year': 'Year',
  'scheduler.years': 'Years',
  'scheduler.monthDay': 'Month Day',
  'scheduler.month': 'Month',
  'scheduler.months': 'Months',
  'scheduler.months.january': 'January',
  'scheduler.months.february': 'February',
  'scheduler.months.march': 'March',
  'scheduler.months.april': 'April',
  'scheduler.months.may': 'May',
  'scheduler.months.june': 'June',
  'scheduler.months.july': 'July',
  'scheduler.months.august': 'August',
  'scheduler.months.september': 'September',
  'scheduler.months.october': 'October',
  'scheduler.months.november': 'November',
  'scheduler.months.december': 'December',
  'scheduler.months.short.january': 'Jan',
  'scheduler.months.short.february': 'Feb',
  'scheduler.months.short.march': 'Mar',
  'scheduler.months.short.april': 'Apr',
  'scheduler.months.short.may': 'May',
  'scheduler.months.short.june': 'Jun',
  'scheduler.months.short.july': 'Jul',
  'scheduler.months.short.august': 'Aug',
  'scheduler.months.short.september': 'Sep',
  'scheduler.months.short.october': 'Oct',
  'scheduler.months.short.november': 'Nov',
  'scheduler.months.short.december': 'Dec',
  'scheduler.actions.manage': 'Manage Scheduler',
  'scheduler.meta.assignedTo': 'Assigned To',
  'scheduler.meta.duration': 'Duration',
  'scheduler.meta.period': 'Period',
  'scheduler.limited': 'The Scheduler is limited to: {{limit}}',
  'scheduler.info.helper': 'Set the scheduler to set a sale period.',
};
